"use strict";

exports.__esModule = true;
exports.SelectionController = void 0;
var _react = require("react");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Provides a selection to consumers.
 */
var SelectionController = exports.SelectionController = /*#__PURE__*/function (_Component) {
  function SelectionController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      selectorPath: undefined,
      // eslint-disable-next-line react/no-unused-state
      selected: _this.props.initialValue,
      // eslint-disable-next-line react/no-unused-state
      setSelection: function setSelection(newState, selectorPath) {
        _this.setState(function () {
          return {
            selectorPath: selectorPath,
            selected: newState
          };
        });
      },
      resetSelection: function resetSelection() {
        _this.setState({
          selectorPath: undefined,
          selected: _this.props.initialValue
        });
      },
      // eslint-disable-next-line react/no-unused-state
      unselect: function unselect(key) {
        _this.setState(function (_ref) {
          var selected = _ref.selected;
          var output = {};
          for (var _i = 0, _Object$keys = Object.keys(selected); _i < _Object$keys.length; _i++) {
            var k = _Object$keys[_i];
            if (k !== key) {
              output[k] = selected[k];
            }
          }
          return {
            selected: output
          };
        });
      },
      isSelectionEmpty: function isSelectionEmpty(dataRange, fetchDataOnlyOnSelection) {
        // applies only when dataRange is set as selection
        return dataRange === "SELECTION" && fetchDataOnlyOnSelection && !_this.state.selectorPath;
      }
    };
    return _this;
  }
  _inheritsLoose(SelectionController, _Component);
  var _proto = SelectionController.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    return this.props.children(this.state);
  };
  return SelectionController;
}(_react.Component);